import React from "react";

/** Single-line table headers; ref forwarded for rc-table measure/sticky behavior. */
const TableHeaderCell = React.forwardRef((props, ref) => {
    const { style, ...rest } = props;
    return (
        <th
            {...rest}
            ref={ref}
            style={{
                ...style,
                whiteSpace: "nowrap",
            }}
        />
    );
});

TableHeaderCell.displayName = "TableHeaderCell";

export default TableHeaderCell;
